<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="vx-row">
    <div class="vx-col w-full sm:w-1/2 md:w-1/3 mb-base">
      <vx-card>
        <div slot="no-body"></div>
        <h5 class="mb-2">{{ this.quest.name }}</h5>
        <p class="text-grey">{{ this.quest.description }}</p>
        <div class="mt-5" v-if="this.quest.access">
            <div><strong>Disponível desde:</strong> {{ formatDate(this.quest.access.start_date) }}</div>
            <div class="mt-3"><strong>Prazo:</strong> {{ formatDate(this.quest.access.end_date) }}</div>
        </div>
        <div class="mt-5" v-if="!this.quest.access">
            <div><strong>Acesso removido. Para mais informações, fale com seu instrutor</strong></div>
        </div>
        <div class="flex justify-between flex-wrap" v-if="!this.quest_submission.submitted_at && this.quest.access">
          <vs-button
            v-if="this.quest_submission.id"
            class="mt-4 shadow-lg"
            color="gray"
            type="filled"
            :href="{url: quest.file_url}"
            target="true"
          >Baixar arquivos</vs-button>
          <div v-if="this.quest_submission.id">
            <vs-button
            @click="finishQuestSubmission()"
            class="mt-4 shadow-lg"
            color="danger"
            type="filled"
          >Finalizar Quest</vs-button>
          </div>
          
          <vs-button
            @click="createQuestSubmission()"
            v-if="!this.quest_submission.id"
            class="mt-4 shadow-lg"
            color="success"
          >Iniciar Quest</vs-button>
        </div>
      </vx-card>
    </div>

    <div class="vx-col w-full sm:w-1/2 md:w-2/3 mb-base">
      <vx-card v-if="this.quest_submission.id">
        <h5 class="mb-2">Arquivos</h5>
        <vs-divider></vs-divider>
        <div class="flex justify-between flex-wrap">
          <quest-submission-file-upload
            v-if="!this.quest_submission.submitted_at && this.quest_submission.files && this.quest_submission.files.length < 3"
            :quest_submission_id="this.quest_submission.id"
            :input_name="'files[]'"
            :post_url="this.upload_url"
          ></quest-submission-file-upload>
        </div>

        <div class="mt-4">
          <vs-table
            v-if="this.quest_submission.files"
            ref="table"
            pagination
            :max-items="5"
            :data="quest_submission.files"
          >
            <template slot="thead">
              <vs-th sort-key="name">Arquivo</vs-th>
              <vs-th sort-key="description">Data</vs-th>
              <vs-th v-if="!quest_submission.submitted_at">Ações</vs-th>
            </template>

            <template>
              <vs-tr :key="indextr" v-for="(tr, indextr) in quest_submission.files">
                <vs-td>
                  <p class="product-name font-medium">
                    <a target="_blank" :href="tr.url">{{ tr.name }}</a>
                  </p>
                </vs-td>
                <vs-td>
                  <p class="product-category">{{ tr.created_at }}</p>
                </vs-td>
                <vs-td v-if="!quest_submission.submitted_at">
                  <vs-button
                    @click="destroyQuestSubmissionFile(tr.id, indextr)"
                    color="danger"
                  >Excluir</vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { getQuest } from "../../_services/quest.service.js";

import {
  getQuestSubmission,
  createQuestSubmission,
  finishQuestSubmission
} from "../../_services/questSubmission.service.js";

import questSubmissionFileService from "../../_services/questSubmissionFile.service.js";

import QuestSubmissionFileUpload from "@/components/zion/QuestSubmissionFileUpload.vue";

export default {
  components: {
    QuestSubmissionFileUpload
  },
  data() {
    const quest_id = this.$route.params.id;
    return {
      upload_url: `${process.env.VUE_APP_API_URL}/questsubmissionfiles`,
      quest_id: quest_id,
      quest: {},
      quest_submission: {}
    };
  },
  mounted() {
    this.$emit("changeRouteTitle", this.quest_id);
  },
  computed: {
    ...mapState({
      account: state => state.account
    })
  },
  methods: {
      formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    async createQuestSubmission() {
      this.$vs.loading();
      this.quest_submission = await createQuestSubmission({
        quest_id: this.quest_id,
        student_id: this.account.user.student.id
      });
      this.$vs.loading.close();
    },
    async finishQuestSubmission() {
      this.$vs.dialog({
        type: "confirm",
        color: 'danger',
        title: `Você tem certeza?`,
        acceptText: "Confirmar",
        cancelText: "Cancelar",
        text:
          "Ao finalizar a quest, você não poderá mais editar os arquivos e/ou o conteúdo da submissão.",
        accept: async () => {
          await finishQuestSubmission({
            quest_submission_id: this.quest_submission.id
          });
          this.fetchQuestSubmission();
          this.$vs.notify({
            color: "success",
            title: "Quest submetida com sucesso!",
            text: "Aguarde pela avaliação do seu professor."
          });
        }
      });
    },

    async destroyQuestSubmissionFile(file_id, index) {
      this.$vs.loading();
      const result = await questSubmissionFileService.destroy(file_id);
      if (result.data) {
        this.quest_submission.files.splice(index, 1);
      }
      this.$vs.loading.close();
    },
    async fetchQuest() {
      this.quest = await getQuest({
        quest_id: this.quest_id
      });
      this.$emit("changeRouteTitle", this.quest.name);
    },
    async fetchQuestSubmission() {
      this.quest_submission = await getQuestSubmission({
        quest_id: this.quest_id,
        student_id: this.account.user.student.id
      });
    }
  },
  created() {
    this.fetchQuest();
    this.fetchQuestSubmission();
  }
};
</script>